import { Box } from "@mui/material";
import imgVertuloo from "../../../../ressources/images/photo_vertuloo.png";
import pointsVert from "../../../../ressources/images/points-vert.png";
import styles from "./styles";

interface IProps {
  classes?: any;
}

const BlocQuiSommesNous = (props: IProps) => (
  <Box className={"container"} sx={styles}>
    <h3>
      Découvrez <span className="vertuloo-font-md vert">vertuloo</span>,<br />
      <strong>la nouvelle plateforme digitale de référence</strong>
      <br />
      développée par <span className={"uppercase"}>Bessé</span> Immobilier &
      Construction
    </h3>
    <div className={"containerTexte"}>
      <div className={"texte"}>
        <div className={"divider"} />
        <p>
          <span className="vertuloo-font-sm vert">vertuloo</span> est la réponse
          aux besoins exprimés par les administrateurs de biens pour la
          sécurisation et le développement de leur activité de gestion locative.
          <br />
          <br />
          Dédiée aux administrateurs de biens, cette plateforme offre une
          solution qui s’appuie sur les technologies les plus avancées, de
          nouveaux modèles d’analyses et des données macroéconomiques et
          sociologiques actualisées en temps réel.
        </p>
      </div>
      <div className={"containerImage"}>
        <img src={pointsVert} className={"dots"} alt="immobilier" width={70} />
        <img src={imgVertuloo} width="400" alt="Vertuloo" />
        <div className={"rectangle"} />
      </div>
    </div>
  </Box>
);

export default BlocQuiSommesNous;
